<template>
    <div ref="scrollList" class="sc-message-list">
        <div v-if="showLoadMessageHistory" v-show="!messagesLoading" class="sc-load-more has-text-centered">
            <e-icon icon="sync" custom-class="is-clickable" @click="$emit('load-message-history')" />
        </div>
        <ChatMessage
            v-for="(message, idx) in messages"
            :key="idx"
            :message="message"
            :chat-image-url="chatImageUrl(message.author)"
            :author-name="authorName(message.author)"
            :colors="colors"
            :message-styling="messageStyling"
        />
        <ChatMessage
            v-show="showTypingIndicator !== null"
            :message="{ author: showTypingIndicator, type: 'typing' }"
            :chat-image-url="chatImageUrl(showTypingIndicator)"
            :colors="colors"
            :message-styling="messageStyling"
        />
    </div>
</template>
<script>
import ChatMessage from '@/components/chat/system/Message.vue';

export default {
    components: { ChatMessage },

    props: {
        participants: {
            type: Array,
            required: true,
        },

        messages: {
            type: Array,
            required: true,
        },

        showTypingIndicator: {
            type: Number,
            default: null,
        },

        colors: {
            type: Object,
            required: true,
        },

        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },

        messageStyling: {
            type: Boolean,
            required: true,
        },

        messagesLoading: {
            type: Boolean,
            default: false,
        },

        messageHistoryCount: {
            type: Number,
            default: 0,
        },
    },

    emits: ['load-message-history'],

    computed: {
        showLoadMessageHistory() {
            return this.messages.length < this.messageHistoryCount;
        },
    },

    mounted() {
        this._scrollDown();
    },

    updated() {
        if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
    },

    methods: {
        _scrollDown() {
            this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
        },

        shouldScrollToBottom() {
            return (
                this.alwaysScrollToBottom || this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - 600
            );
        },

        profile(author) {
            const profile = this.participants.find(participant => participant.id === author);

            // A profile may not be found for system messages or messages by authUser.id
            return profile || { photo_url: '', name: '' };
        },

        chatImageUrl(author) {
            return this.profile(author).photo_url;
        },

        authorName(author) {
            return this.profile(author).name;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.sc-message-list {
    height: 80%;
    overflow-y: auto;
    background-size: 100%;
    padding: $column-gap;
}

.sc-load-more {
    margin: $column-gap 0;
}

.sc-load-more i {
    cursor: pointer;
}

@media (max-width: 450px) {
    .sc-message-list {
        height: auto;
    }
}
</style>
